import React, { useState, useEffect } from "react";

import { useMutation } from "@tanstack/react-query";
import axios from "axios";



export default function usePostPersonalAccountInfo() {
    function toDateString(date: Date | null): string | null {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const post = async (postData?) => {
        console.log(postData)
        postData.BirthDay = postData?.BirthDay ? toDateString(postData.BirthDay) : null;
        postData.PassportDate = postData?.PassportDate ? toDateString(postData.PassportDate) : null;

        const response = await axios.post("/ProfileApi/UpdatePersonalAccountInfo", postData);
        return response.data;
    }

    const { mutate, data, isPending, isError, isSuccess, error } = useMutation({
        mutationKey: ["UpdatePersonalAccountInfo"],
        mutationFn: post,
        onSuccess: (data) => {
            console.log("%c UpdatePersonalAccountInfo успешно:", "color: #b885f2; font-weight: bold; font-size: 16px;", data);
        },
        onError: (error) => {
            console.log("%c UpdatePersonalAccountInfo ошибка:", "color: #f08181; font-weight: bold; font-size: 16px;", error);
        },
    });

    return { mutate, data, isPending, isError, isSuccess, error }
}